export const HALL_THEMES = [
  {
    id: "bubblegum",
    label: "Bubblegum",
    swatch: "#fb7185",
    swatch2: "#22d3ee",
    cageMetal: "#f472b6",
    glass: "#fce7f3",
    ambient: "#ffe4ef",
    hemiSky: "#fff1f7",
    hemiGround: "#9d174d",
    dir: "#fff7ed",
    mixLight: "#67e8f9",
    callLight: "#fda4af",
    marks: ["🫧", "💖", "🍬", "🌸", "🍭", "💜"],
  },
  {
    id: "neon-glow",
    label: "Neon",
    swatch: "#22d3ee",
    swatch2: "#e879f9",
    cageMetal: "#67e8f9",
    glass: "#c4b5fd",
    ambient: "#c4b5fd",
    hemiSky: "#e9d5ff",
    hemiGround: "#1e1b4b",
    dir: "#f5d0fe",
    mixLight: "#22d3ee",
    callLight: "#f0abfc",
    marks: ["⚡", "✨", "💫", "🌈", "🔮", "💜"],
  },
  {
    id: "tropical",
    label: "Tropical",
    swatch: "#f97316",
    swatch2: "#14b8a6",
    cageMetal: "#fb923c",
    glass: "#ccfbf1",
    ambient: "#ffedd5",
    hemiSky: "#fff7ed",
    hemiGround: "#9a3412",
    dir: "#fef9c3",
    mixLight: "#5eead4",
    callLight: "#fdba74",
    marks: ["🌴", "🍋", "🌺", "🍉", "🍍", "🌊"],
  },
  {
    id: "candy",
    label: "Candy",
    swatch: "#f472b6",
    swatch2: "#a855f7",
    cageMetal: "#e879f9",
    glass: "#fce7f3",
    ambient: "#fae8ff",
    hemiSky: "#fdf4ff",
    hemiGround: "#6b21a8",
    dir: "#fef9c3",
    mixLight: "#f9a8d4",
    callLight: "#d8b4fe",
    marks: ["🍬", "🍭", "🍩", "🧁", "🍓", "🎀"],
  },
  {
    id: "space",
    label: "Space",
    swatch: "#818cf8",
    swatch2: "#c084fc",
    cageMetal: "#a5b4fc",
    glass: "#c7d2fe",
    ambient: "#c7d2fe",
    hemiSky: "#e0e7ff",
    hemiGround: "#0b1020",
    dir: "#e9d5ff",
    mixLight: "#818cf8",
    callLight: "#d8b4fe",
    marks: ["🚀", "⭐", "🌙", "🪐", "✨", "👽"],
  },
  {
    id: "retro",
    label: "Retro",
    swatch: "#22d3ee",
    swatch2: "#f472b6",
    cageMetal: "#fde047",
    glass: "#fef08c",
    ambient: "#fef9c3",
    hemiSky: "#fef08c",
    hemiGround: "#312e81",
    dir: "#e0f2fe",
    mixLight: "#22d3ee",
    callLight: "#f9a8d4",
    marks: ["🕹️", "👾", "📼", "🌈", "💾", "📺"],
  },
  {
    id: "halloween",
    label: "Halloween",
    swatch: "#f97316",
    swatch2: "#c026d3",
    cageMetal: "#fb923c",
    glass: "#fed7aa",
    ambient: "#ffedd5",
    hemiSky: "#fed7aa",
    hemiGround: "#2d1b4e",
    dir: "#fdba74",
    mixLight: "#e879f9",
    callLight: "#fb923c",
    marks: ["🎃", "👻", "🦇", "🕷️", "🍬", "🌙"],
  },
  {
    id: "christmas",
    label: "Holiday",
    swatch: "#dc2626",
    swatch2: "#16a34a",
    cageMetal: "#fbbf24",
    glass: "#d9f99d",
    ambient: "#fefce8",
    hemiSky: "#dcfce7",
    hemiGround: "#450a0a",
    dir: "#fef9c3",
    mixLight: "#86efac",
    callLight: "#fca5a5",
    marks: ["🎄", "❄️", "🎁", "🎅", "⭐", "🔔"],
  },
  {
    id: "valentine",
    label: "Rose",
    swatch: "#e11d48",
    swatch2: "#fb7185",
    cageMetal: "#fb7185",
    glass: "#fce7f3",
    ambient: "#fce7f3",
    hemiSky: "#fbcfe8",
    hemiGround: "#4c0519",
    dir: "#ffe4e6",
    mixLight: "#fda4af",
    callLight: "#fb7185",
    marks: ["💕", "🌹", "💘", "💗", "🎀", "💋"],
  },
] as const;

export type HallThemeId = (typeof HALL_THEMES)[number]["id"];

const LEGACY: Record<string, HallThemeId> = {
  brass: "bubblegum",
  neon: "neon-glow",
  felt: "tropical",
  ice: "space",
};

export function isHallThemeId(value: unknown): value is HallThemeId {
  return HALL_THEMES.some((theme) => theme.id === value);
}

export function coerceHallThemeId(value: unknown): HallThemeId {
  if (isHallThemeId(value)) return value;
  if (typeof value === "string" && value in LEGACY) return LEGACY[value] as HallThemeId;
  return "bubblegum";
}

export function hallTheme(id: HallThemeId) {
  return HALL_THEMES.find((theme) => theme.id === id) ?? HALL_THEMES[0];
}
